import {Link} from "react-router-dom";
import "./Video.css";

export function Video(props) {
    let video = props.video;
    return <Link to={`/video/${video.id}`}><div className="video">
        <div className="video-thumbnail" style={{backgroundImage: `url(${video.thumbnail})`}}></div>
        <div className="video-title">{video.title}</div>
    </div></Link>
}